import type { ExternalSiteRule } from "../../types";
import { SITE_TYPE } from "./const";

const naverSmartstore: ExternalSiteRule = {
  type: SITE_TYPE,

  getInfo: async ({ responseUrl }) => {
    if (!responseUrl.includes("smartstore.naver.com")) {
      return "INVALID";
    }

    return {
      siteType: SITE_TYPE,
      url: responseUrl,
      siteInfo: {
        type: SITE_TYPE,
      },
      title: "스마트스토어",
    };
  },

  pageRules: [],
};

export default naverSmartstore;
